import { useUpdateEffect } from 'react-use';

import { useFormController } from '@dreryk/react-common';
import { dispatchSnackbarInformativeEvent } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { StyledPatientSearch } from './PatientSearch.styled';

const PATIENT_SEARCH_MAX_LENGTH = 100;

type PatientSearchFormBean = {
   searchText: string | null;
};

type PatientSearchProps = {
   readonly onPatientSearchChanged: (searchText: string | null) => void;
};

export const PatientSearch = (props: PatientSearchProps): JSX.Element => {
   const { register, watch } = useFormController<PatientSearchFormBean>({ searchText: null });
   const searchText = watch('searchText');

   useUpdateEffect(() => {
      if (searchText && searchText.length > PATIENT_SEARCH_MAX_LENGTH) {
         dispatchSnackbarInformativeEvent(patientTranslationKeys.searchReachedMaxNumberOfCharacters);
         return;
      }

      props.onPatientSearchChanged(searchText);
   }, [searchText]);

   return (
      <StyledPatientSearch
         controller={register('searchText')}
         placeholder={patientTranslationKeys.searchPlaceholder}
         autoFocus
         testId={'searchText'}
      />
   );
};
